import EntityType from "@mapmycustomers/shared/enum/EntityType";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import {
  EditorRouteCompanyStop,
  EditorRouteManualStop,
  EditorRoutePersonStop,
  EditorRouteStop,
} from "../types/RouteStop";

// Single source of truth for the editor-stop discriminator. The manual predicate especially
// is shared by collectCreateStopItems / getAppendStopsOperations (what we send to preview) and
// correlateManualStopsToPreview (how we read the preview back). The preview pairing is
// positional, so both sides MUST agree on which stops count — keeping that here makes it
// structural rather than comment-enforced.
export const isCompanyStop = (stop: EditorRouteStop): stop is EditorRouteCompanyStop =>
  stop.entity === EntityType.COMPANY && isDefined(stop.accountId);

export const isPersonStop = (stop: EditorRouteStop): stop is EditorRoutePersonStop =>
  stop.entity === EntityType.PERSON && isDefined(stop.contactId);

export const isManualStop = (
  stop: EditorRouteStop
): stop is EditorRouteManualStop & { id: number } => stop.entity === null && isDefined(stop.id);
